var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._t("default",null,{"config":{ toggleState: _vm.toggleState, opened: _vm.opened, currentChevronIcon: _vm.currentChevronIcon }})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }